import * as Sentry from "@sentry/react";

const isSentryEnabled = () => {
  const origin = window.location.origin;
  const allowedOrigins = [
    // "http://localhost:4500",
    "https://production.vozohealth.com",
  ];
  return allowedOrigins.includes(origin);
};

const getSentryEnvironment = () => {
  const origin = window.location.origin;

  if (origin.includes("localhost")) {
    return "development";
  }

  if (origin === "https://production.vozohealth.com") {
    return "production";
  }

  return "production";
};

export const initializeSentry = () => {
  if (!isSentryEnabled()) {
    return;
  }
  Sentry.init({
    dsn: "https://99674b9877a0092c1f6cd5103a7305b2@o4511620526112768.ingest.us.sentry.io/4511620637261824",
    environment: getSentryEnvironment(),

    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
  });
};

export const withSentryBoundary = (Component) => {
  if (!isSentryEnabled()) {
    return <Component />;
  }

  return (
    <Sentry.ErrorBoundary fallback={<div>Something went wrong</div>}>
      <Component />
    </Sentry.ErrorBoundary>
  );
};
